export default "/images/indoor_play_env_sm.jpg?9fa44493428e755167c30e7b5cebd253";